/* eslint-disable no-async-promise-executor */
import { UploadedFile } from "../dropzone/types";
import { uploadFile } from "./client-upload-service";

const uploadFileWithProgress = (
  fileId: string,
  file: File,
  clientId: number,
  setUploadedFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>,
): Promise<{ fileId: string; message: string } | null> => {
  return new Promise(async (resolve) => {
    let progress = 0;
    let backendDone = false;
    let errorResult: { fileId: string; message: string } | null = null;

    const updateProgress = (p: number) => {
      setUploadedFiles((prev) =>
        prev.map((f) =>
          f.id === fileId ? { ...f, progress: Math.min(p, 100) } : f,
        ),
      );
    };

    const simulateConversion = () =>
      new Promise<void>((res) => {
        let convert = 0;

        const interval = setInterval(() => {
          const step = Math.random() * 2 + 1;
          convert += step;

          progress = convert;
          updateProgress(progress);

          if (convert >= 20) {
            clearInterval(interval);
            res();
          }
        }, 40);
      });

    await simulateConversion();

    const fileData: string = await new Promise((res, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result.split(",")[1];
        res(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

    const fileSizeMB = file.size / (1024 * 1024);
    const baseSpeed = Math.max(30, 130 - fileSizeMB * 10);

    const backendPromise = uploadFile({
      clientId,
      fileData,
      fileName: file.name,
    })
      .then(() => {
        backendDone = true;
      })
      .catch(() => {
        backendDone = true;
        errorResult = {
          fileId,
          message: `Failed to upload file ${file.name}.`,
        };
      });

    const uploadInterval = setInterval(() => {
      if (!backendDone) {
        const stallChance = Math.random() < 0.05;
        const jitter = Math.random() * 3;

        if (!stallChance) progress += jitter;

        if (progress > 90) progress = 90;

        updateProgress(progress);
      } else {
        progress += 2.8;

        updateProgress(progress);

        if (progress >= 100) {
          clearInterval(uploadInterval);
          resolve(errorResult);
        }
      }
    }, baseSpeed);

    await backendPromise;
  });
};

export default uploadFileWithProgress;
